import { useEffect, useState } from "react";
import api from "@/lib/api";

let _cache = null;
let _inflight = null;

/** Returns the singleton site_settings doc. Cached in-memory after first fetch. */
export default function useSiteSettings() {
  const [data, setData] = useState(_cache);
  useEffect(() => {
    if (_cache) return;
    if (!_inflight) {
      _inflight = api.get("/public/site-settings").then(r => { _cache = r.data; return r.data; });
    }
    _inflight.then(d => setData(d)).catch(() => setData({}));
  }, []);
  return data;
}

export function clearSiteSettingsCache() {
  _cache = null;
  _inflight = null;
}
